import React from 'react';

type Props = {
  code: string; // e.g. "pl", "en"
  locale?: string; // e.g. "en" → in which language the name should be displayed
  className?: string;
};

const LanguageName: React.FC<Props> = ({ code, locale = 'en', className }) => {
  const displayNames = new Intl.DisplayNames([locale], { type: 'language' });
  return <span className={className}>{displayNames.of(code)}</span>;
};

export default LanguageName;
